<template>
     <!--Contact Three Start-->
     <section class="contact-three">
            <div class="contact-three-shape"
                style="background-image: url(assets/images/shapes/contact-three-shape.png);"></div>
            <div class="container">
                <div class="section-title text-center">
                    <!-- <span class="section-title__tagline">Contáctanos</span> -->
                     <h2 class="section-title__title">Cotiza con nosotros <!--<br> para cualquier duda--> </h2> 
                </div>
                <div class="contact-page__form-box">
                    <form class="contact-page__form contact-form-validated"
                        novalidate="novalidate">
                        <div class="row">
                            <div class="col-xl-6">
                                <div class="contact-form__input-box">
                                    <input type="text" placeholder="Tu nombre" name="nombre" v-model="nombre">
                                </div>
                            </div>
                            <div class="col-xl-6">
                                <div class="contact-form__input-box">
                                    <input type="email" placeholder="Correo Electrónico" name="correo" v-model="correo">
                                </div>
                            </div>
                            <div class="col-xl-6">
                                <div class="contact-form__input-box">
                                    <input type="text" placeholder="Teléfono" name="telefono" v-model="telefono">
                                </div>
                            </div>
                            <div class="col-xl-6">
                                <div class="contact-form__input-box">
                                    <input type="text" placeholder="Asunto" name="asunto" v-model="asunto">
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-xl-12">
                                <div class="contact-form__input-box text-message-box">
                                    <textarea name="mensaje" placeholder="Escribe un Mensaje" v-model="mensaje"></textarea>
                                </div>
                                <div class="contact-form__btn-box">
                                    <!--button type="button" class="thm-btn contact-form__btn" @click="contacto">Enviar Mensaje</button-->
                                    <button 
                                        type="button" 
                                        class="thm-btn contact-form__btn" 
                                        @click="contacto"
                                        :disabled="enviando"
                                    >
                                        {{ enviando ? 'Enviando...' : 'Enviar Mensaje' }}
                                    </button>

                                </div>
                                <!--  -->
                                <div class="alert alert-success d-flex align-items-center botonC" role="alert" v-if="divShow"> 
                                   
                                    <!-- <svg class="bi flex-shrink-0 me-2" width="24" height="24" role="img" aria-label="Success:"><use xlink:href="#check-circle-fill"/></svg> -->
                                    <div >
                                        <span class="fas fa-check-circle bi flex-shrink-0 me-2 iconC"></span>
                                    </div>

                                    <div>
                                        <p style="text-align: center; font-size: 26px;">Su correo se ha enviado</p>
                                    </div>
                                     
                                </div>

                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </section>
        <!--Contact Three End-->

</template>


<style>

    .contact-three{
        padding: 60px 0 120px;
    }
    .botonC{
        margin-top: 30px; 
        height: auto; 
        width: 100%; 
        border-radius: 8px;
    }

    .iconC{
        font-size: 20px; 
        margin-left: 190px;
        margin-right: 10px;
    }
</style>

<script>

import Services from '@/services/correo.js'

export default {
    
    data() {
    return {
      nombre : '',
      correo : '',
      telefono : '',
      asunto : '',
      mensaje : '',
      divShow: false,
      enviando: false
    }
    
  },
  methods: {
  contacto() {

    if (!this.nombre || !this.correo || !this.telefono || !this.asunto || !this.mensaje) {
      alert('Complete los campos restantes');
      return;
    }

    this.enviando = true; // 🔒 Desactiva botón

    const formulario = {
      nombre: this.nombre,
      correo: this.correo,
      telefono: this.telefono,
      asunto: this.asunto,
      mensaje: this.mensaje,
    };

    Services.enviar(formulario)
      .then(response => {

        if (response.data.result) {
          this.divShow = true;

          setTimeout(() => {
            this.divShow = false;
          }, 10000);

          // 🧹 LIMPIAR FORMULARIO
          this.nombre = '';
          this.correo = '';
          this.telefono = '';
          this.asunto = '';
          this.mensaje = '';
        }

      })
      .catch(error => {
        console.log(error);
      })
      .finally(() => {
        this.enviando = false; // 🔓 Reactiva botón pase lo que pase
      });
    }
  }
}
    
</script>